export default {
  isShown: (state) => state.isShown,
  privateOffersLoading: (state) => state.privateOffersLoading,
  name: (state) => state.formData.name,
  validFrom: (state) => state.formData.validFrom,
  validTo: (state) => state.formData.validTo,
  createdAt: (state) => state.formData.createdAt,
  countries: (state) => state.formData.countries,
  services: (state) => state.formData.services,
  manager: (state) => state.formData.manager,
  slug: (state) => state.formData.slug,
  affiliate: (state) => state.formData.affiliate,
  topBanner: (state) => state.formData.topBanner,
  bottomBanner: (state) => state.formData.bottomBanner,
  isCountdownEnabled: (state) => state.formData.isCountdownEnabled,
  offerId: (state) => state.offerId,
  errors: (state) => state.errors,
};
